// prescripto-store-locator-geocoded.js
// Rebuilt by assistant: preserved original 77 locations and added smooth camera + marker animations (bounce + fade)
const locations = [
  {
    "name": "Ali Mall",
    "city": "Quezon City, Metro Manila",
    "address": "Under Ground Floor, Near Olympic Village Store",
    "lat": 14.6197,
    "lng": 121.0568
  },
  {
    "name": "Ayala Malls Fairview Terraces",
    "city": "Quezon City, Metro Manila",
    "address": "Under Ground Floor, Near Bench",
    "lat": 14.7365,
    "lng": 121.0602
  },
  {
    "name": "Ayala Malls Feliz",
    "city": "Pasig, Metro Manila",
    "address": "2nd Floor, Front Of Office Warehouse & Edamama",
    "lat": 14.6200,
    "lng": 121.0931
  },
  {
    "name": "Ayala Malls Glorietta",
    "city": "Makati, Metro Manila",
    "address": "3rd Floor, Near Globe",
    "lat": 14.5515,
    "lng": 121.0254
  },
  {
    "name": "Ayala Malls Manila Bay",
    "city": "Parañaque, Metro Manila",
    "address": "3rd Floor, Beside Keycard",
    "lat": 14.5227,
    "lng": 120.9905
  },
  {
    "name": "Ayala Malls Marquee Mall",
    "city": "Angeles City, Pampanga",
    "address": "2nd Floor, Infront World Balance",
    "lat": 15.1627,
    "lng": 120.6101
  },
  {
    "name": "Citimart",
    "city": "Rizal Ave, Batangas",
    "address": "Franchise - Vinnies",
    "lat": 13.7554,
    "lng": 121.0531
  },
  {
    "name": "CSI Mall Dagupan",
    "city": "Dagupan, Pangasinan",
    "address": "Ground Floor, Infront Shakey'S & World Of Fun",
    "lat": 16.0237,
    "lng": 120.3236
  },
  {
    "name": "CSI Mall Dagupan",
    "city": "Dagupan, Pangasinan",
    "address": "Near Sandugo & Efteeworld",
    "lat": 16.0237,
    "lng": 120.3236
  },
  {
    "name": "Ever Gotesco Mall Commonwealth Center",
    "city": "Quezon City, Metro Manila",
    "address": "Infront Of Greenwich And Abenson",
    "lat": 14.6782,
    "lng": 121.0855
  },
  {
    "name": "Farmers Plaza",
    "city": "Quezon City, Metro Manila",
    "address": "4th floor, Near Escalator, Inront Of Massage Chair",
    "lat": 14.6206,
    "lng": 121.0517
  },
  {
    "name": "Farmers Plaza",
    "city": "Quezon City, Metro Manila",
    "address": "3rd Floor Near The Atrium And World Balance Store",
    "lat": 14.6206,
    "lng": 121.0517
  },
  {
    "name": "Festival Mall",
    "city": "Muntinlupa, Metro Manila",
    "address": "Lower Ground Floor, Infront Of Japan Homes And Red Ribbon",
    "lat": 14.4175,
    "lng": 121.0406
  },
  {
    "name": "Imall Canlubang",
    "city": "Calamba, Laguna",
    "address": "Inbetween Handyman & Greenwich",
    "lat": 14.2135,
    "lng": 121.1176
  },
  {
    "name": "Isetann Cinerama Complex",
    "city": "Recto Ave, Quipo, Manila",
    "address": "Ground Floor, Near Jollibee",
    "lat": 14.6034,
    "lng": 120.9846
  },
  {
    "name": "Jenra Mall",
    "city": "Angeles City, Pampanga",
    "address": "Ground Floor, Infront Jolibee",
    "lat": 15.1363,
    "lng": 120.5878
  },
  {
    "name": "Magic Mall Urdaneta",
    "city": "Urdaneta, Pangasinan",
    "address": "2nd Floor, Near Penshoppe",
    "lat": 15.9758,
    "lng": 120.5681
  },
  {
    "name": "Magic Star Mall",
    "city": "Tarlac City",
    "address": "Upper Ground Floor Entrance, Near Jolbee & Bny",
    "lat": 15.4869,
    "lng": 120.5873
  },
  {
    "name": "Metro Central Mall",
    "city": "Santa Cruz, Laguna",
    "address": "1st Floor, Near Diy Store",
    "lat": 14.2435,
    "lng": 121.3895
  },
  {
    "name": "Metro Point Mall",
    "city": "Pasay, Metro Manila",
    "address": "3rd Floor, Infront Of World Balance",
    "lat": 14.5383,
    "lng": 121.0012
  },
  {
    "name": "Metro Town Mall",
    "city": "Tarlac City",
    "address": "Ground Floor, Infront Elevator",
    "lat": 15.4888,
    "lng": 120.5967
  },
  {
    "name": "Metro Town Mall",
    "city": "Tarlac City",
    "address": "Near Transfer It & Cindy'S",
    "lat": 15.4880,
    "lng": 120.5975
  },
  {
    "name": "Nepo Mall",
    "city": "Dagupan, Pangasinan",
    "address": "Ground Floor, Infront Magic Appliance & Mang Inasal",
    "lat": 16.0512,
    "lng": 120.3418
  },
  {
    "name": "Nepo Mall - Angeles City",
    "city": "Angeles City, Pampanga",
    "address": "Ground Floor, Infront Pizza Hut & National Bookstore",
    "lat": 15.1350,
    "lng": 120.5886
  },
  {
    "name": "Nepo Mall - Angeles City",
    "city": "Angeles City, Pampanga",
    "address": "2nd Floor, Near Mr. Diy Shop",
    "lat": 15.1350,
    "lng": 120.5886
  },
  {
    "name": "Nova Plaza Mall",
    "city": "Quezon City, Metro Manila",
    "address": "Ground Floor Front Of Chook To Go",
    "lat": 14.7215,
    "lng": 121.0406
  },
  {
    "name": "Nuciti Central Mall",
    "city": "Poblacion, Batangas",
    "address": "Franchise - Vinnies",
    "lat": 13.7604,
    "lng": 121.0571
  },
  {
    "name": "Pavilion Mall",
    "city": "Binan, Laguna",
    "address": "2nd Floor, Bldg.A Hallway Near Otto",
    "lat": 14.3280,
    "lng": 121.0879
  },
  {
    "name": "Pinoy General Trading L.L.C",
    "city": "Dubai - United Arab Emirates",
    "address": "8 Al Suq St - Al Souq Al Kabeer - Al Fahidi - Dubai - United Arab Emirates",
    "lat": 25.2634,
    "lng": 55.2922
  },
  {
    "name": "Riverbanks Center",
    "city": "Marikina, Metro Manila",
    "address": "Ground Floor, Front Of Savemore & Tribal",
    "lat": 14.6293,
    "lng": 121.0820
  },
  {
    "name": "Robinsons Angeles",
    "city": "Angeles City, Pampanga",
    "address": "2nd Floor, Infront Daiso",
    "lat": 15.1574,
    "lng": 120.5918
  },
  {
    "name": "Robinsons Galleria",
    "city": "Quezon City, Metro Manila",
    "address": "Basement 1, Near Bdo & Infront Of Salazar Dental Clinic",
    "lat": 14.5912,
    "lng": 121.0601
  },
  {
    "name": "Robinsons Place Imus",
    "city": "Cavite",
    "address": "2nd Floor, Front Of Eo Executive Optical",
    "lat": 14.4131,
    "lng": 120.9415
  },
  {
    "name": "Robinsons Place Manila",
    "city": "Metro Manila",
    "address": "2nd Floor Near Adriatco Wing, Front Of Lee",
    "lat": 14.5995,
    "lng": 120.9842
  },
  {
    "name": "Robinsons Starmills Pampanga",
    "city": "San Fernando, Pampanga",
    "address": "Ground Floor, Near Super Market",
    "lat": 15.0497,
    "lng": 120.6979
  },
  {
    "name": "SM Center Angono",
    "city": "Angono, Rizal",
    "address": "Ground Floor, Front Of Sm Supermarket And Giligans",
    "lat": 14.5310,
    "lng": 121.1547
  },
  {
    "name": "SM Center Antipolo Downtown",
    "city": "Antipolo",
    "address": "Ground Floor, Front Of Giligans And Alberto",
    "lat": 14.6247,
    "lng": 121.1338
  },
  {
    "name": "SM Center Lemery",
    "city": "Lemery, Batangas",
    "address": "Franchise - Vinnies",
    "lat": 13.8870,
    "lng": 120.9119
  },
  {
    "name": "SM City Bacoor",
    "city": "Bacoor, Cavite",
    "address": "3rd Floor, Front Of Toby'S Sports",
    "lat": 14.4452,
    "lng": 120.9510
  },
  {
    "name": "SM City Baguio",
    "city": "Baguio, Benguet",
    "address": "Lower Ground Floor, Infront Aficionado Near Classic Savory",
    "lat": 16.4090,
    "lng": 120.600
  },
  {
    "name": "Sm City Baliwag",
    "city": "Baliwag, Bulacan",
    "address": "Ground Floor, Infront Of Red Ribbon",
    "lat": 14.9603,
    "lng": 120.8904
  },
  {
    "name": "SM City Batangas",
    "city": "Batangas",
    "address": "Franchise - Vinnies",
    "lat": 13.7562,
    "lng": 121.0695
  },
  {
    "name": "SM City Bicutan",
    "city": "Parañaque, Metro Manila",
    "address": "Bldg.A Uground Floor, Front Of Alberto, Beside Zenzest",
    "lat": 14.4873,
    "lng": 121.0446
  },
  {
    "name": "SM City Calamba",
    "city": "Calamba, Laguna",
    "address": "2nd Floor, Front Of Bench Body/Crocs",
    "lat": 14.2043,
    "lng": 121.1552
  },
  {
    "name": "SM City Clark",
    "city": "Angeles City, Pampanga",
    "address": "Ground Floor, Infront Time Depot Near Hypermarket",
    "lat": 15.1674,
    "lng": 120.5801
  },
  {
    "name": "SM City Clark",
    "city": "Angeles City, Pampanga",
    "address": "Ground Floor, Infront Gerry'S Grill, Near K1109",
    "lat": 15.1674,
    "lng": 120.5801
  },
  {
    "name": "SM City Dasmariñas",
    "city": "Dasmariñas, Cavite",
    "address": "Lower Ground Floor, Front Of Barrio Fiesta",
    "lat": 14.3019,
    "lng": 120.9568
  },
  {
    "name": "SM City Fairview",
    "city": "Quezon City, Metro Manila",
    "address": "Lower Ground Floor, Near Toy Kingdom And Ojo Eye Wear",
    "lat": 14.7347,
    "lng": 121.0585
  },
  {
    "name": "SM City Lipa",
    "city": "Lipa City, Batangas",
    "address": "Franchise - Vinnies",
    "lat": 13.9548,
    "lng": 121.1640
  },
  {
    "name": "SM City Lucena",
    "city": "Lucena City, Quezon",
    "address": "Franchise - Vinnies",
    "lat": 13.9405,
    "lng": 121.6253
  },
  {
    "name": "SM City Manila",
    "city": "Metro Manila",
    "address": "2nd Floor, Near Watsons",
    "lat": 14.5900,
    "lng": 120.9831
  },
  {
    "name": "SM City Marilao",
    "city": "Marilao, Bulacan",
    "address": "Ground Floor, Infront Of Jolibee",
    "lat": 14.7539,
    "lng": 120.9556
  },
  {
    "name": "SM City Molino",
    "city": "Bacoor, Cavite",
    "address": "2nd Floor, Front Of SM Dept. Store",
    "lat": 14.3832,
    "lng": 120.9779
  },
  {
    "name": "SM City North Edsa",
    "city": "Quezon City, Metro Manila",
    "address": "3rd Floor Annex Bldg. Infront Of Gameone, Near Office Ware House",
    "lat": 14.6569,
    "lng": 121.0315
  },
  {
    "name": "SM City Pampanga",
    "city": "San Fernando, Pampanga",
    "address": "Ground Floor, Infront Jolibee, Near Mang Inasal",
    "lat": 15.0522,
    "lng": 120.6995
  },
  {
    "name": "SM City Pampanga",
    "city": "San Fernando, Pampanga",
    "address": "Ground Floor, Infront Burger King, Near Cyber Zone",
    "lat": 15.0522,
    "lng": 120.6995
  },
  {
    "name": "SM City Rosales",
    "city": "Rosales, Pangasinan",
    "address": "Ground Floor, Infront Jag, Near Aqua Flask",
    "lat": 15.8783,
    "lng": 120.6028
  },
  {
    "name": "SM City San Lazaro",
    "city": "Santa Cruz, Manila",
    "address": "Lower Ground Floor, Front Of Dermtrends And Ibarra Restaurant",
    "lat": 14.6185,
    "lng": 120.9864
  },
  {
    "name": "SM City San Mateo",
    "city": "San Mateo, Rizal",
    "address": "3rd Floor, Near Shawarma Shack, Dunkin Donuts, Takoyadon",
    "lat": 14.6802,
    "lng": 121.1150
  },
  {
    "name": "SM City San Pablo",
    "city": "San Pablo, Laguna",
    "address": "Franchise - Vinnies",
    "lat": 14.0716,
    "lng": 121.3022
  },
  {
    "name": "SM City Santa Rosa",
    "city": "Santa Rosa, Laguna",
    "address": "Ground Floor / Front Of Owndays And Gongcha, Near Contis",
    "lat": 14.3128,
    "lng": 121.0989
  },
  {
    "name": "SM City Sta. Mesa",
    "city": "Quezon City, Metro Manila",
    "address": "Lower Ground Floor, Front Of Goldilocks And Gongcha",
    "lat": 14.6044,
    "lng": 121.0191
  },
  {
    "name": "SM City Sucat",
    "city": "Muntinlupa, Metro Manila",
    "address": "Bldg.A - 2nd Floor, Front Of Escalator And Tongyang",
    "lat": 14.4827,
    "lng": 120.9938
  },
  {
    "name": "SM City Tarlac",
    "city": "Tarlac City",
    "address": "2nd Floor, Infront Greenwich",
    "lat": 15.4775,
    "lng": 120.5951
  },
  {
    "name": "SM City Tarlac",
    "city": "Tarlac City",
    "address": "Near Dexter Watch Zone",
    "lat": 15.4775,
    "lng": 120.5951
  },
  {
    "name": "SM City Taytay",
    "city": "Taytay, Metro Manila",
    "address": "Bldg.A, Ground Floor, Front Of Pancake House",
    "lat": 14.5650,
    "lng": 121.1401
  },
  {
    "name": "SM City Telabastagan",
    "city": "San Fernando, Pampanga",
    "address": "Ground Floor, Infront Mcdonald'S",
    "lat": 15.1203,
    "lng": 120.6022
  },
  {
    "name": "SM City Urdaneta Central",
    "city": "Urdaneta, Pangasinan",
    "address": "2nd Floor, Infront Chris Sports, Near Elevator",
    "lat": 15.9712,
    "lng": 120.5722
  },
  {
    "name": "SM City Valenzuela",
    "city": "Valenzuela, Metro Manila",
    "address": "2nd Floor, Front Of Giligans And Picture Picture",
    "lat": 14.6857,
    "lng": 120.9777
  },
  {
    "name": "SM Megamall",
    "city": "Mandaluyong, Metro Manila",
    "address": "Under Ground Floor, Bldg.A, Between Bea Bi & St. Paul",
    "lat": 14.5856,
    "lng": 121.0570
  },
  {
    "name": "SM Megamall",
    "city": "Mandaluyong, Metro Manila",
    "address": "Lower Ground Floor, Bldg.A, Infront Of Jamaican Pattie Shop",
    "lat": 14.5856,
    "lng": 121.0570
  },
  {
    "name": "SM Shopper's Mate",
    "city": "Hsinchu City, Taiwan",
    "address": "No. 117號, Dongmen St, East District, Hsinchu City, Taiwan 300",
    "lat": 24.8040,
    "lng": 120.9696
  },
  {
    "name": "SM Southmall",
    "city": "Las Piñas, Metro Manila",
    "address": "Ground Floor, Front Of Lechon Hause And Cosmolash",
    "lat": 14.4334,
    "lng": 121.0111
  },
  {
    "name": "Southgate Mall",
    "city": "Makati, Metro Manila",
    "address": "2nd Floor, Beside Levis Jeans",
    "lat": 14.5411,
    "lng": 121.0196
  },
  {
    "name": "Sta.Lucia Mall",
    "city": "Cainta, Metro Manila",
    "address": "2nd Floor, Sta. Lucia Dept Store",
    "lat": 14.6181,
    "lng": 121.1003
  },
  {
    "name": "Starmall Edsa-Shaw",
    "city": "Mandaluyong, Metro Manila",
    "address": "Ground Floor, Alongside Jollibee",
    "lat": 14.5830,
    "lng": 121.0539
  },
  {
    "name": "Tutuban Center",
    "city": "Tondo, Metro Manila",
    "address": "Ground Floor, Near Jollibee Entrance",
    "lat": 14.6070,
    "lng": 120.9741
  },
  {
    "name": "Venice Grand Canal Mall",
    "city": "Taguig, Metro Manila",
    "address": "2nd Floor, Beside Imono",
    "lat": 14.5343,
    "lng": 121.0520
  },
  {
    "name": "Victory Plaza (Victory Mall)",
    "city": "Caloocan, Metro Manila",
    "address": "Lower Ground Floor Beside Lotto Outlet",
    "lat": 14.6558,
    "lng": 120.9835
  }
];

// Globals
let map;
let markers = [];
let infoWindow;
let currentSelectedIndex = null;

// Initialize map and markers
function initMap() {
  // Default center (if locations present, center on first)
  const defaultCenter = locations && locations.length ? { lat: locations[0].lat, lng: locations[0].lng } : { lat: 14.5995, lng: 120.9842 };
  map = new google.maps.Map(document.getElementById('store-locator-map'), {
    center: defaultCenter,
    zoom: 12,
    gestureHandling: 'greedy'
  });

  infoWindow = new google.maps.InfoWindow();
  buildStoreList();
  addMarkers();
  initSearch();
}

// Add markers to map
function addMarkers() {
  markers = [];
  locations.forEach((loc, idx) => {
    const marker = new google.maps.Marker({
      position: { lat: loc.lat, lng: loc.lng },
      map,
      title: loc.name,
      optimized: true,
      opacity: 0.9
    });

    marker.addListener('click', () => {
      selectStore(idx);
    });

    markers.push(marker);
  });
}

// Build sidebar store list
function buildStoreList() {
  const container = document.getElementById('store-items');
  container.innerHTML = '';
  locations.forEach((loc, idx) => {
    const div = document.createElement('div');
    div.className = 'store-item';
    div.setAttribute('data-index', idx);
    div.innerHTML = `<strong>${loc.name}</strong><br>${loc.address || loc.city || ''}`;
    div.addEventListener('click', (e) => {
      // single tap selection - smooth camera + marker animation
      selectStore(idx);
      // close sidebar on mobile (matches HTML behavior)
      const sidebar = document.getElementById('sidebar');
      if (window.innerWidth <= 768 && sidebar) sidebar.classList.remove('active');
    });
    container.appendChild(div);
  });
}

// Select store by index: pan/zoom + animate marker + open info window
function selectStore(idx) {
  if (!locations[idx]) return;

  // Deselect previous
  markers.forEach((m, i) => {
    m.setOpacity(i === idx ? 1 : 0.6);
    if (i === currentSelectedIndex && m.getAnimation()) {
      m.setAnimation(null);
    }
  });

  const marker = markers[idx];
  currentSelectedIndex = idx;

  // Bounce animation for selected marker
  marker.setAnimation(google.maps.Animation.BOUNCE);
  setTimeout(() => marker.setAnimation(null), 1400);

  // Ensure marker is fully visible and highlighted
  marker.setOpacity(1);

  // Smooth camera: pan then zoom in, then slight zoom out for camera effect
  smoothCameraTo(locations[idx].lat, locations[idx].lng, 15, 13.5, 900);

  // Info window content
  const content = `
    <div style="min-width:180px">
      <strong>${locations[idx].name}</strong><br>
      ${locations[idx].address || ''}<br>
      ${locations[idx].city || ''}
    </div>
  `;
  infoWindow.setContent(content);
  infoWindow.open(map, marker);
}

// Smooth camera movement: pans immediately, then animates zoom in/out
function smoothCameraTo(lat, lng, zoomIn=15, zoomOut=13.5, zoomInDuration=700) {
  if (!map) return;
  const target = new google.maps.LatLng(lat, lng);
  map.panTo(target);

  // Smooth zoom in by incrementing zoom level
  const startZoom = map.getZoom();
  const step = (zoomIn > startZoom) ? 1 : -1;
  let z = startZoom;
  const zoomInterval = setInterval(() => {
    if ((step > 0 && z >= zoomIn) || (step < 0 && z <= zoomIn)) {
      clearInterval(zoomInterval);
      // hold then zoom out slightly
      setTimeout(() => {
        animateZoomTo(zoomOut);
      }, 800);
      return;
    }
    z += step;
    map.setZoom(z);
  }, Math.max(50, Math.floor(zoomInDuration / Math.abs(zoomIn - startZoom || 1))));
}

// Animate zoom to a target zoom (smooth)
function animateZoomTo(targetZoom) {
  const current = map.getZoom();
  const step = targetZoom > current ? 1 : -1;
  let z = current;
  const interval = setInterval(() => {
    if ((step > 0 && z >= targetZoom) || (step < 0 && z <= targetZoom)) {
      clearInterval(interval);
      return;
    }
    z += step;
    map.setZoom(z);
  }, 120);
}

// Search / filter functionality
function initSearch() {
  const input = document.getElementById('store-search');
  if (!input) return;
  input.addEventListener('input', function() {
    const q = this.value.trim().toLowerCase();
    const items = document.querySelectorAll('.store-item');
    locations.forEach((loc, i) => {
      const text = ((loc.name||'') + ' ' + (loc.address||'') + ' ' + (loc.city||'')).toLowerCase();
      const match = text.indexOf(q) !== -1;
      items[i].style.display = match ? '' : 'none';
      markers[i].setMap(match ? map : null);
    });
  });
}

// Close sidebar when tapping outside on mobile (keeps parity with HTML)
document.addEventListener('click', function(e) {
  const sidebar = document.getElementById('sidebar');
  const toggleButton = document.querySelector('.toggle-sidebar');
  if (!sidebar) return;
  const isMobile = window.innerWidth <= 768;
  if (isMobile && sidebar.classList.contains('active') && !sidebar.contains(e.target) && !(toggleButton && toggleButton.contains(e.target))) {
    sidebar.classList.remove('active');
  }
});

// Expose initMap globally for Google Maps callback
window.initMap = initMap;
